import templateArrayItemString from '../../../views/partials/formArrayString.handlebars';
import templateArrayItemTextarea from '../../../views/partials/formArrayTextarea.handlebars';
import templateArrayItemRecipes from '../../../views/partials/formArrayRecipes.handlebars';
import templateArrayItemComposition from '../../../views/partials/formArrayComposition.handlebars';
import templateArrayItemExercises from '../../../views/partials/formArrayExercises.handlebars';
import templateArrayItemTrainings from '../../../views/partials/formArrayTrainings.handlebars';
import templateArrayItemProgramms from '../../../views/partials/formArrayProgramms.handlebars';
import templateArrayItemPractices from '../../../views/partials/formArrayPractices.handlebars';
import templateArrayItemSection from '../../../views/partials/formArraySection.handlebars';
import CookiesJS from 'cookies-js';

export function initAddButtons($, apiClient) {
    $('body').on('click', '.array-item-remove', async function () {
        $(this).parent().parent().remove();
        feather.replace();
    });
    $('body').on('click', '.array-item-add-string', async function () {
        $(this).parent().parent().find('.array-items')
            .append(templateArrayItemString());
        feather.replace();
    });
    // У блока раздела своя кнопка удаления: разметка глубже, чем
    // у строки-текстарии, и общий обработчик снёс бы не тот узел.
    $('body').on('click', '.array-item-remove-section', async function () {
        $(this).closest('.array-item').remove();
        feather.replace();
    });
    $('body').on('click', '.array-item-add-section', async function () {
        $(this).parent().parent().find('.array-items')
            .append(templateArrayItemSection({}));
        feather.replace();
        $('.selectpicker-custom').selectpicker();
    });
    $('body').on('click', '.array-item-add-textarea', async function () {
        $(this).parent().parent().find('.array-items')
            .append(templateArrayItemTextarea());
        feather.replace();
    });
    $('body').on('click', '.array-item-add-practices', async function () {
        const practices = await apiClient.getList('/practices', { lite: true }, CookiesJS.get('auth_token'));
        $(this).parent().parent().find('.array-items')
            .append(templateArrayItemPractices({
                practices,
                rowId: Math.random().toString().split('.')[1],
            }));
        feather.replace();
        $('.selectpicker-custom').selectpicker();
    });
    $('body').on('click', '.array-item-add-recipes', async function () {
        const recipes = await apiClient.getList('/recipes', { lite: true }, CookiesJS.get('auth_token'));
        $(this).parent().parent().find('.array-items')
            .append(templateArrayItemRecipes({
                recipes,
                rowId: Math.random().toString().split('.')[1],
            }));
        feather.replace();
        $('.selectpicker-custom').selectpicker();
    });
    $('body').on('click', '.array-item-add-composition', async function () {
        const products = await apiClient.getList('/products', { lite: true }, CookiesJS.get('auth_token'));
        $(this).parent().parent().find('.array-items')
            .append(templateArrayItemComposition({
                products,
                rowId: Math.random().toString().split('.')[1],
            }));
        feather.replace();
        $('.selectpicker-custom').selectpicker();
    });
    $('body').on('click', '.array-item-add-exercises', async function () {
        const exercises = await apiClient.getList('/exercises', { lite: true }, CookiesJS.get('auth_token'));
        $(this).parent().parent().find('.array-items')
            .append(templateArrayItemExercises({
                exercises,
                rowId: Math.random().toString().split('.')[1],
            }));
        feather.replace();
        $('.selectpicker-custom').selectpicker();
    });
    $('body').on('click', '.array-item-add-trainings', async function () {
        const trainings = await apiClient.getList('/trainings', { lite: true }, CookiesJS.get('auth_token'));
        $(this).parent().parent().find('.array-items')
            .append(templateArrayItemTrainings({
                trainings,
                rowId: Math.random().toString().split('.')[1],
            }));
        feather.replace();
        $('.selectpicker-custom').selectpicker();
    });
    $('body').on('click', '.array-item-add-programms', async function () {
        const _id = $('#object_id').val();
        if (!_id) {
            alert('Добавление программ недоступно при создании пользователя');
            return;
        }
        const programms = await apiClient.getList('/programms', { userId: _id }, CookiesJS.get('auth_token'));
        $(this).parent().parent().find('.array-items')
            .append(templateArrayItemProgramms({
                programms,
                rowId: Math.random().toString().split('.')[1],
            }));
        feather.replace();
        $('.selectpicker-custom').selectpicker();
    });

    $('.selectpicker-custom').selectpicker();
}
